export default "__VITE_ASSET__8d5877c5__"